var App = App || {};

App.WidgetQuickLinks = (function ($) {
    'use strict';

    function Init(widget) {
        const animate = widget;
        animate.ZagScrollAnimate({
            targets: [
                { selector: ".widget-quickLinks__layout", type: "animate__fadeInUp", stagger: 0 }
            ]
        });
    }

    return {
        Init: Init
    };

})(jQuery);